import { isTouchDevice } from '@/scripts/utils';
import eventHub from '@/scripts/eventHub';
import MouseManger from './mouse';
import TouchManger from './touch';

class InteractionManager {
  constructor(DOMElement) {
    this.DOMElement = DOMElement;
    this.DOMRect = null;
    this.point = { x: 0, y: 0 };
    this.manager = null;

    this.hold = () => {};
    this.release = () => {};

    this.resize();

    this.resizeHandler = () => { this.resize(); };
    eventHub.$on('window-resize', this.resizeHandler);

    if (isTouchDevice()) {
      this.manager = new TouchManger(this);
    } else {
      this.manager = new MouseManger(this);
    }
  }

  resize() {
    this.DOMRect = this.DOMElement.getBoundingClientRect();
    this.boundings = { top: this.DOMRect.top, left: this.DOMRect.left };
    this.center = { x: this.DOMRect.width / 2, y: this.DOMRect.height / 2 };
  }

  start() {
    this.manager.addEvents();
  }

  stop() {
    this.manager.removeEvents();
  }

  destroy() {
    eventHub.$off('window-resize', this.resizeHandler);
    this.manager = null;
  }
}

export default InteractionManager;
